import React from 'react';

import classNames from 'classnames';

import { SimpleLoader } from './SimpleLoader';

interface AlertProps {
  className?: string;
  children?: React.ReactNode | React.ReactNode[] | string;
  loading?: boolean;
  type?: 'error' | 'info';
}

export const Alert = ({
  className = '',
  loading = false,
  children,
  type = 'info',
}: AlertProps): JSX.Element => {
  let color = 'bg-blue-1.0';
  if (type === 'error') color = 'bg-red-1.0';
  return (
    <div
      className={classNames(
        `${color} flex items-center p-2 text-sm text-white-0.0 rounded`,
        className
      )}
      role="alert"
    >
      {loading && <SimpleLoader />}
      <span className={loading ? 'ml-2' : ''}>{children}</span>
    </div>
  );
};
